import { render, staticRenderFns } from "./NewWhatsappPage.vue?vue&type=template&id=b11f7370&scoped=true&"
import script from "./NewWhatsappPage.vue?vue&type=script&lang=ts&"
export * from "./NewWhatsappPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewWhatsappPage.vue?vue&type=style&index=0&id=b11f7370&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11f7370",
  null
  
)

export default component.exports